import * as React from "react";
import { Route, Switch } from "react-router-dom";

import Cabecalho from "./Cabecalho";
import Rodape from "./Rodape";

import AlterarSenha from "./AlterarSenha";
import Login from "./Login";
import RecuperarSenha from "./RecuperarSenha";
import Resultados from "./Resultados";
import ResultadosFiltro from "./ResultadosFiltro";

import { Container } from "semantic-ui-react";
import IdentificacaoPaciente from "./IdentificacaoPaciente";
import Popup from "react-popup";
import "react-popup/style.css"
import Vacinas from "./Vacinas";

export default function Main() {
    const [inApp, setInApp] = React.useState(false);

    const style = {};

    if (inApp) {
        style.marginTop = 20;
    }

    return (
        <Container fluid style={style}>
            <Popup />
            {inApp ? null : <Cabecalho />}
            <Container>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={(props) => {
                            setInApp(false);
                            return <Login {...props} />;
                        }}
                    />
                    <Route path="/resultados" component={Resultados} />
                    <Route path="/identificacaoPaciente" component={IdentificacaoPaciente} />
                    <Route path="/resultadosFiltro" component={ResultadosFiltro} />
                    <Route path="/vacinas" component={Vacinas} />
                    <Route path="/alterarSenha" component={AlterarSenha} />
                    <Route path="/recuperarSenha" component={RecuperarSenha} />
                    <Route
                        path="/App"
                        render={({ location: { search }, ...props }) => {
                            const token = search.replace(/.*token=([^&]+).*/g, "$1");
                            console.log(token);
                            localStorage.setItem("token", token);
                            setInApp(true);
                            return <Resultados {...props} />;
                        }}
                    />
                </Switch>
            </Container>
            {inApp ? null : <Rodape fluid />}
        </Container>
    );
}
